import { useEffect } from 'react';
import { useLocation, useNavigate, matchPath } from 'react-router-dom';

import { RootRoutePath } from 'applications/GSP/shared/constants/router';
import { useGetHomePageRoutePath } from 'applications/GSP/shared/hooks/router';

export const useHomePageRedirect = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const homePageRoutePath = useGetHomePageRoutePath();

  useEffect(() => {
    if (matchPath(RootRoutePath.Home, pathname)) {
      navigate(homePageRoutePath);
    }
  }, [pathname, navigate, homePageRoutePath]);
};
